import { searchInsuranceRequirements } from '../../../api/portal-api';
import { withSearchBlueprint } from '../../blueprints/search';

const INSUREDS_SET_COLUMNS = 'INSUREDS_SET_COLUMNS';

/* Actions
================================================== */
export const setInsuredsColumns = columns => dispatch => {
  dispatch({ type: INSUREDS_SET_COLUMNS, columns });
};

const DEFAULT_STATE = { columns: [] };

const insuredsReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export const { reducer, ...insuredSearch } = withSearchBlueprint('insureds', insuredsReducer, {
  endpoint: searchInsuranceRequirements,
  defaultSort: [{ id: 'insured', desc: false }],
  globalSearchIndices: [
    'insured.external_id^2',
    'parent_insured.external_id',
    'item.properties.value',
    'insured.company_name',
    'parent_insured.company_name',
    'insurance_requirement.contract_number',
    'job.number'
  ],
  lengthAwarePagination: false,
  aggregates: {
    primary_source_key: 'insured.id',
    primary_source_name: 'insured_id',
    nested_size: 6
  }
});
